export function cbChunkMove(folder, data) {
    const source = folder.parentPath === '/' ? '/' + folder.name : folder.parentPath + '/' + folder.name;
    return data.push(source);
}
